import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.47 1.867H3.62a.749.749 0 0 0-.75.75v1.6H1.63a.755.755 0 0 0-.75.75v6.45a2.234 2.234 0 0 0 2.24 2.23h8.86a2.234 2.234 0 0 0 2.24-2.23v-8.8a.755.755 0 0 0-.75-.75ZM2.87 10.8c0 .27-.49.27-.49 0V5.717h.49Zm9.85.62a.736.736 0 0 1-.74.73H3.73a1.734 1.734 0 0 0 .64-1.35V3.367h8.35Zm-.41-6.03a.749.749 0 0 1-.75.75H5.6a.75.75 0 0 1 0-1.5h5.96a.755.755 0 0 1 .75.747Zm0 2.33a.749.749 0 0 1-.75.75H9.69a.75.75 0 1 1 0-1.5h1.87a.755.755 0 0 1 .75.747Zm0 1.92a.755.755 0 0 1-.75.75H9.69a.75.75 0 1 1 0-1.5h1.87a.749.749 0 0 1 .75.747ZM8.03 7.357v2.77H5.6v-2.77Z';
const draw24px =
  'M18.81,20.75H5.26a3,3,0,0,1-3-3V7.87A.75.75,0,0,1,3,7.12H5.27V4.28A.75.75,0,0,1,6,3.53H21.08a.74.74,0,0,1,.75.75V17.73A3,3,0,0,1,18.81,20.75ZM4.51,19.06a1.58,1.58,0,0,0,.75.19H18.81a1.52,1.52,0,0,0,1.52-1.52V5H6.77V16.79A2.27,2.27,0,0,1,4.51,19.06ZM3.74,8.62v8.17a.77.77,0,1,0,1.53,0V8.62Zm15.17-.1a.75.75,0,0,0-.75-.75H9.06a.75.75,0,1,0,0,1.5h9.1A.76.76,0,0,0,18.91,8.52Zm0,3.56a.75.75,0,0,0-.75-.75H15.3a.75.75,0,0,0,0,1.5h2.86A.76.76,0,0,0,18.91,12.08Zm0,2.92a.76.76,0,0,0-.75-.75H15.3a.75.75,0,0,0,0,1.5h2.86A.75.75,0,0,0,18.91,15Zm-6.14-3.48H9.06v4.24h3.71Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const NewspaperIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'newspaper'),
) as IconWithRender;

NewspaperIcon.displayName = 'NewspaperIcon';
NewspaperIcon.propTypes = Icon.propTypes;
NewspaperIcon.renderIcon = (props) => <NewspaperIcon {...props} />;
export default NewspaperIcon;
